import { render, staticRenderFns } from "./ModalResources.vue?vue&type=template&id=15a98f58&scoped=true"
import script from "./ModalResources.vue?vue&type=script&lang=js"
export * from "./ModalResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a98f58",
  null
  
)

export default component.exports